import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  clientMutation,
  clientQuery,
} from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  equipmentSelected: null,
  equipment: null,
  error: null,
  id: null,
  updateManageEquipmentResult: null,
};

const route = "modules/manage/modals/createEditManageEquipment/redux/slice";

export const manageGetManageEquipment = createAsyncThunk(
  "manage/createEditManageEquipment/getManageEquipment",
  async ({ id }, { rejectWithValue }) => {
    try {
      const query = `
            query ($id: Int!){
                data: getEquipment(id: $id){
                    id
                    name
                    unitsCount
                    vehicles {
                        id
                        unitId
                        unit {
                            id
                            label
                        }
                    }
                }
            }
          `;
      const response = await clientQuery(
        query,
        { id },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageGetManageEquipment");
      return rejectWithValue(exc);
    }
  }
);

export const manageCreateEditManageEquipment = createAsyncThunk(
  "manage/createEditManageEquipment/createEditManageEquipment",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
              mutation (
                  ${payload.id ? "$id: Int!," : ""}
                  $name: String!,
                  $units: [Int]
              ) {
                  data: ${payload.id ? "updateEquipment" : "createEquipment"} (
                      ${payload.id ? "id: $id," : ""}
                      name: $name,
                      units: $units
                  ) {
                      id
                  }
              }
          `;
      const response = await clientMutation(
        mutation,
        payload,
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageCreateEditManageEquipment");
      return rejectWithValue(exc);
    }
  }
);

const manageCreateEditManageEquipmentRedux = createSlice({
  name: "manage/createEditManageEquipment",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalCreateEditManageEquipment(state, action) {
      state.open = true;
      state.equipmentSelected = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageGetManageEquipment
    builder.addCase(manageGetManageEquipment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageGetManageEquipment.fulfilled, (state, action) => {
      state.loading = false;
      state.equipment = action.payload;
    });
    builder.addCase(manageGetManageEquipment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //manageCreateEditManageEquipment
    builder.addCase(manageCreateEditManageEquipment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      manageCreateEditManageEquipment.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateManageEquipmentResult = action.payload;
      }
    );
    builder.addCase(
      manageCreateEditManageEquipment.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    );
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditManageEquipmentRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditManageEquipment } = actions;

// Export the reducer, either as a default or named export
export default reducer;
